export const c8rTermsAndConditionsLink =
  "https://cloudchipr.com/terms-conditions";
